import React, {Dispatch, SetStateAction} from 'react';
import {useTranslation} from 'react-i18next';

import DateFilter from './DateFilter';

type Suffix = 'Before' | 'After';

type DateRangeField<T extends string> = Partial<Record<`${T}${Suffix}`, Date>>;

const DateRangeFilter = <T extends string, F extends DateRangeField<T>>({
    field,
    filters,
    setFilters,
}: {
    field: T;
    filters: F;
    setFilters: Dispatch<SetStateAction<F>>;
}): JSX.Element => {
    const {t} = useTranslation(['DateRangeFilter']);

    return (
        <div className="d-flex gap-2">
            <DateFilter
                id={`${field}-after`}
                label={t('DateRangeFilter:after', 'After')}
                field={`${field}After`}
                filters={filters}
                setFilters={setFilters}
            />
            <DateFilter
                id={`${field}-before`}
                label={t('DateRangeFilter:before', 'Before')}
                field={`${field}Before`}
                filters={filters}
                setFilters={setFilters}
            />
        </div>
    );
};

export default DateRangeFilter;
